/**
 * 【KYMW1407】使用画像登録
 *
 * @export RegistUseImageModel
 * @class RegistUseImageModel
 */
export class RegistUseImageModel {
  // コマID
  public komaId = String('');
  // 画像ID
  public imageId = String('');
  // Pコード
  public pcode = String('');
  // 表示順
  public showSeq: number = null;
}
